export enum WidgetShowType {
  ON = 'ON',
  OFF = 'OFF',
  BY_WIDGET = 'BY_WIDGET',
}
